import styled from 'styled-components'

import Field from 'components/Form/components/Field'

export const RatioBarFieldStyled = styled(Field)`
  .Label {
    margin-right: 1em !important;
  }
`
